import type { IconSvgObject } from './types';

const LassoIcon: IconSvgObject = [
  ["ellipse", { cx: "6.99609", cy: "16", rx: "3", ry: "2", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8.99609 22C6.23467 22 3.99609 19.3137 3.99609 16", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7.28603 18C8.68956 18.6382 10.2931 19 11.9961 19C17.5189 19 21.9961 15.1944 21.9961 10.5C21.9961 5.80558 17.5189 2 11.9961 2C6.47325 2 1.99609 5.80558 1.99609 10.5C1.99609 12.4139 2.74027 14.1801 3.99609 15.6008", stroke: "currentColor", strokeWidth: "1.5", key: "2" }]
];

export default LassoIcon;
